/* blomz-product-card.js - selvforsynt produktkort uten apper
 *
 * Tre oppgaver:
 *   1. Variantvalg: swatch (farge/metall) og pills (stoerrelse) velger variant.
 *      Swatch-klikk bytter kortets bilde og pris med en myk overgang, og
 *      pills graanes ut naar kombinasjonen er utsolgt.
 *   2. KJOEP: AJAX-legg-i-kurv av valgt variant. Kunden blir paa siden;
 *      butikkens handlekurv-varsel (cart-notification) aapnes og telleren i
 *      headeren oppdateres - samme oppfoersel som tett visning.
 *   3. Delegerte hendelser, slik at kort fra filtrering/infinite scroll
 *      virker uten ny oppkobling.
 *
 * Variantdataene ligger som JSON i hvert kort (data-bz-variants), skrevet av
 * snippets/blomz-product-card.liquid. Ingen apper, ingen eksterne kall.
 */
(function () {
  'use strict';

  if (window.__bzCardReady) return;
  window.__bzCardReady = true;

  var SWAP_MS = 180;

  /* Fjerner width-parameteren slik at samme motiv i ulike stoerrelser
     sammenlignes likt. */
  function plainUrl(u) {
    return (u || '').split('&width=')[0];
  }

  /* ------------------------------------------------------------- data --- */

  function variantsOf(card) {
    if (card.__bzVariants) return card.__bzVariants;
    var el = card.querySelector('[data-bz-variants]');
    if (!el) return [];
    try {
      card.__bzVariants = JSON.parse(el.textContent);
    } catch (e) {
      card.__bzVariants = [];
    }
    return card.__bzVariants;
  }

  /* Valg indeksert etter opsjonsposisjon (data-opt-index), ikke DOM-rekkefoelge.
     Grupper med bare en verdi rendres ikke; posisjonen deres blir null og
     betyr "hva som helst" i matchingen. */
  function selectionOf(card) {
    var count = (variantsOf(card)[0] || { options: [] }).options.length;
    var picked = [];
    for (var i = 0; i < count; i++) picked.push(null);
    card.querySelectorAll('[data-bz-opt-group]').forEach(function (group) {
      var idx = Number(group.dataset.optIndex) - 1;
      var on = group.querySelector('[data-bz-opt][aria-pressed="true"]');
      if (idx >= 0 && on) picked[idx] = on.dataset.value;
    });
    return picked;
  }

  function matchVariant(card, selection) {
    var variants = variantsOf(card);
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var hit = true;
      for (var j = 0; j < selection.length; j++) {
        if (selection[j] !== null && v.options[j] !== selection[j]) {
          hit = false;
          break;
        }
      }
      if (hit) return v;
    }
    return null;
  }

  /* Er en gitt verdi i en gruppe kjoepbar sammen med valgene i de ANDRE
     gruppene? Brukes til aa graane ut utsolgte kombinasjoner fortloepende. */
  function valueBuyable(card, groupIndex, value, selection) {
    var variants = variantsOf(card);
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v.available) continue;
      if (v.options[groupIndex] !== value) continue;
      var ok = true;
      for (var j = 0; j < selection.length; j++) {
        if (j === groupIndex) continue;
        if (selection[j] !== null && v.options[j] !== selection[j]) {
          ok = false;
          break;
        }
      }
      if (ok) return true;
    }
    return false;
  }

  /* ------------------------------------------------------- visning --- */

  function swapImage(card, variant) {
    var img = card.querySelector('[data-bz-image]');
    if (!img || !variant.src) return;
    if (plainUrl(img.currentSrc || img.src).indexOf(plainUrl(variant.src)) === 0) return;

    img.classList.add('is-swapping');
    setTimeout(function () {
      img.src = variant.src;
      if (variant.srcset) img.srcset = variant.src + ' 600w, ' + variant.srcset + ' 900w';
      var done = function () {
        img.classList.remove('is-swapping');
        img.removeEventListener('load', done);
      };
      img.addEventListener('load', done);
      /* Sikkerhetsnett om load-hendelsen uteblir (cachet bilde). */
      setTimeout(done, 600);
    }, SWAP_MS);
  }

  function renderState(card, fromUser) {
    var selection = selectionOf(card);
    var variant = matchVariant(card, selection);

    /* Graane ut kombinasjoner som ikke er kjoepbare. */
    card.querySelectorAll('[data-bz-opt-group]').forEach(function (group) {
      var gi = Number(group.dataset.optIndex) - 1;
      group.querySelectorAll('[data-bz-opt]').forEach(function (btn) {
        var buyable = valueBuyable(card, gi, btn.dataset.value, selection);
        btn.classList.toggle('is-unavailable', !buyable);
      });
    });

    if (!variant) return;

    /* Pris (og foer-pris ved salg). */
    var now = card.querySelector('[data-bz-price-now]');
    if (now) now.textContent = variant.price;
    var wrap = card.querySelector('[data-bz-price]');
    var was = card.querySelector('[data-bz-compare]');
    if (wrap) {
      if (variant.on_sale && variant.compare_at) {
        if (!was) {
          was = document.createElement('s');
          was.className = 'bz-card__price-was';
          was.setAttribute('data-bz-compare', '');
          wrap.insertBefore(was, wrap.firstChild);
        }
        was.textContent = variant.compare_at;
        wrap.classList.add('bz-card__price--sale');
      } else {
        if (was) was.remove();
        wrap.classList.remove('bz-card__price--sale');
      }
    }

    /* Bilde. Kortets opprinnelige motiv huskes foer foerste bytte. */
    var img = card.querySelector('[data-bz-image]');
    if (img && !card.__bzHome) card.__bzHome = plainUrl(img.currentSrc || img.src);
    swapImage(card, variant);

    /* Modell-hoverbildet hoerer til kortets standardmotiv. Naar kunden
       selv velger en variant med et annet bilde, skjules overlegget -
       ellers ligger det oppaa og skjuler bildebyttet saa lenge pekeren er
       over kortet. Settes KUN ved brukerklikk: ved sidelast skal hover
       alltid virke, uansett smaa URL-forskjeller mellom bildereferansene. */
    if (fromUser && img && variant.src && card.__bzHome) {
      var awayFromHome = plainUrl(variant.src).indexOf(card.__bzHome) !== 0;
      card.classList.toggle('bz-card--picked', awayFromHome);
    }

    /* KJOEP-knappen foelger valgt variant. */
    var buy = card.querySelector('[data-bz-add]');
    if (buy) {
      buy.dataset.variantId = variant.id;
      buy.dataset.available = variant.available ? 'true' : 'false';
      var label = buy.querySelector('[data-bz-buy-label]');
      if (variant.available) {
        buy.removeAttribute('aria-disabled');
        if (label) label.textContent = label.dataset.labelBuy || 'KJØP';
      } else {
        buy.setAttribute('aria-disabled', 'true');
        if (label) label.textContent = label.dataset.labelSoldout || 'Utsolgt';
      }
    }
  }

  /* --------------------------------------------------------- handlekurv --- */

  function cartComponent() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function renderCartIcon(sections) {
    var target = document.getElementById('cart-icon-bubble');
    if (!target || !sections || !sections['cart-icon-bubble']) return;
    var parsed = new DOMParser()
      .parseFromString(sections['cart-icon-bubble'], 'text/html')
      .querySelector('.shopify-section');
    if (parsed) target.innerHTML = parsed.innerHTML;
  }

  function addToCart(button) {
    var card = button.closest('[data-bz-card]');
    if (!card || button.classList.contains('is-loading')) return;
    if (button.dataset.available === 'false') return;

    button.classList.add('is-loading');

    var component = cartComponent();
    var sectionIds = ['cart-icon-bubble'];
    if (component && typeof component.getSectionsToRender === 'function') {
      component.getSectionsToRender().forEach(function (section) {
        if (sectionIds.indexOf(section.id) === -1) sectionIds.push(section.id);
      });
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
        sections: sectionIds,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) { return response.json(); })
      .then(function (result) {
        if (result.status) {
          /* Avvist (utsolgt e.l.) - vis kort feiltilstand. */
          button.classList.remove('is-loading');
          var label = button.querySelector('[data-bz-buy-label]');
          if (label) {
            var original = label.textContent;
            label.textContent = result.description || result.message || label.dataset.labelSoldout;
            setTimeout(function () { label.textContent = original; }, 1800);
          }
          return;
        }

        if (component) {
          try {
            if (typeof component.setActiveElement === 'function') component.setActiveElement(button);
            component.renderContents(result);
          } catch (e) {
            console.error('[bz-card] Handlekurv-varselet kunne ikke tegnes:', e);
          }
        }
        renderCartIcon(result.sections);

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'blomz-product-card',
            productVariantId: button.dataset.variantId,
          });
        }

        button.classList.remove('is-loading');
        button.classList.add('is-added');
        setTimeout(function () { button.classList.remove('is-added'); }, 1200);
      })
      .catch(function (e) {
        console.error('[bz-card] Kunne ikke legge varen i handlekurven:', e);
        button.classList.remove('is-loading');
      });
  }

  /* ---------------------------------------------------------- oppstart --- */

  /* Utsolgte varianter skal synes allerede ved sidelast, ikke foerst etter
     et klikk. Kort som injiseres senere (filtrering/paginering) faar samme
     merking server-side fra snippet-en, saa en engangs-init holder. */
  function initAll() {
    document.querySelectorAll('[data-bz-card]').forEach(function (card) {
      if (card.__bzInit) return;
      card.__bzInit = true;
      card.classList.remove('bz-card--picked');
      renderState(card, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* --------------------------------------------------------- hendelser --- */

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    /* Lukkekryss i stoerrelse-popupen. */
    var popClose = event.target.closest('[data-bz-pop-close]');
    if (popClose) {
      event.preventDefault();
      var closingPop = popClose.closest('[data-bz-pop]');
      if (closingPop) closingPop.setAttribute('hidden', '');
      return;
    }

    var opt = event.target.closest('[data-bz-opt]');
    if (opt) {
      event.preventDefault();
      var group = opt.closest('[data-bz-opt-group]');
      group.querySelectorAll('[data-bz-opt]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === opt ? 'true' : 'false');
      });
      var optCard = opt.closest('[data-bz-card]');
      renderState(optCard, true);

      /* Valg gjort inne i popupen: legg varianten rett i kurven og lukk,
         men bare naar den valgte kombinasjonen faktisk er kjoepbar. */
      var insidePop = opt.closest('[data-bz-pop]');
      if (insidePop) {
        var popBuy = optCard.querySelector('[data-bz-add]');
        if (popBuy && popBuy.dataset.available !== 'false') {
          insidePop.setAttribute('hidden', '');
          addToCart(popBuy);
        }
      }
      return;
    }

    var buy = event.target.closest('[data-bz-add]');
    if (buy) {
      event.preventDefault();
      var buyCard = buy.closest('[data-bz-card]');
      var pop = buyCard && buyCard.querySelector('[data-bz-pop]');
      if (pop) {
        /* Skjult stoerrelsesvalg: KJOP aapner popupen i stedet for aa
           legge rett i kurven - saa lenge noe i det hele tatt er paa lager. */
        var anyAvailable = variantsOf(buyCard).some(function (v) {
          return v.available;
        });
        if (!anyAvailable) return;
        pop.removeAttribute('hidden');
        return;
      }
      addToCart(buy);
      return;
    }

    /* Klikk paa selve popup-bakgrunnen (utenfor knappene) lukker den. */
    if (event.target.hasAttribute && event.target.hasAttribute('data-bz-pop')) {
      event.target.setAttribute('hidden', '');
    }
  });
})();
